export default __webpack_public_path__ + "static/media/football-active.f2e20f61.webp";